<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
            <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-0 pt-10" :class="{ pointerEventsNull: isFieldDisabled }">
        <b-col cols="10" lg="4">
          <div class="answers pl-32">
            <b-form-select disabled v-if="componentData.options">
              <option
                v-for="choice in componentData.options"
                disabled
                :key="choice.id"
                :value="choice.body"
                v-html="choice.formattedBody"
                v-translate:_formattedBody="{
                  key: translationKeyInitial,
                  val: lang,
                  optionId: choice.id,
                  optionLable: '_options_',
                  html: choice.formattedBody
                }"
              ></option>
            </b-form-select>
          </div>
        </b-col>
      </b-row>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row>
        <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            class="ml-2 question-tital-name"
            :class="isFieldDisabled ? 'disable-question' : ''"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable"
            :class="isFieldDisabled ? 'disable-question' : ''"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
          <span class="text-danger pl-5 fw-bold" v-if="hasFieldError">{{ fieldErrorText }}</span>
          <span class="text-warning pl-5 fw-bold" v-else-if="hasFieldWarning">{{ fieldWarningText }}</span>
        </b-col>
      </b-row>

      <b-row class="mb-10 mt-5 pl-30" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="10" lg="4">
          <b-form-select v-model="componentData.answer" :disabled="isFieldDisabled" size="sm" name="formDropdownPreview" class="fs-12 field-h40" v-validate="!componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined) ? 'required' : ''" @change="onFieldChange($event)">
            <option key value>&nbsp;</option>
            <option
              v-for="choice in componentData.options"
              :disabled="isFieldDisabled"
              :key="choice.id"
              :value="choice.body"
              v-html="choice.formattedBody"
              v-translate:_formattedBody="{
                key: translationKeyInitial,
                val: lang,
                optionId: choice.id,
                optionLable: '_options_',
                html: choice.formattedBody
              }"
            ></option>
          </b-form-select>
          <b-col cols="8"></b-col>
        </b-col>
      </b-row>
      <div :class="[isRTLlang(lang) ? 'float-right' : '', isFieldDisabled ? 'disable-question' : '']">
        <span class="activity-form__clear pl-45" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-25" v-if="activityInfo.canScoreResponses">
          <label class="fs-12 pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
      <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
    </template>

    <!-- RESPONSE MODE -->
    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col cols="10" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
          <div class="number-sequence">
            <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
            <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
          </div>
          <span
            class="ml-2 question-tital-name"
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.formattedBody
            }"
            v-html="componentData.formattedBody"
          ></span>
          <span
            v-if="componentData.isSkippable && (isFieldDisabled == false || isFieldDisabled == undefined)"
            class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2"
            v-translate:_optional="{
              key: 'label',
              val: lang,
              html: 'Optional'
            }"
            >Optional</span
          >
          <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
            Skipped
          </div>
        </b-col>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div
            v-translate:_formattedBody="{
              key: translationKeyInitial,
              val: lang,
              optionId: componentData.optionId,
              optionLable: '_options_',
              html: componentData.answer
            }"
            :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '']"
          >
            {{ componentData.answer }}
          </div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-dropdown-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      scoresMap: {}
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && !!this.componentData.answer && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    hasFieldError(val) {
      this.componentData.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.componentData.fieldErrorText = val;
    },
    hasFieldWarning(val) {
      this.componentData.hasFieldWarning = val;
    },
    fieldWarningText(val) {
      this.componentData.fieldWarningText = val;
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.validateIt();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    }
  },
  mounted() {
    try {
      this.calculateScoresMap();
    } catch (e) {}
    if (this.mode == 1) {
      this.insertOtherOption();
      this.$emit("initAnswerChange", this.componentData);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      } else {
        if (this.componentData.answer) {
          const option = this.componentData.options.find(option => option.body == this.componentData.answer);
          this.componentData.actualScore = option.score;
          this.componentData.computedScore = option.score;
        }
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    isScoreExcluded(answer) {
      let excludeScore = false;
      const option = this.componentData.options.find(option => option.body == answer);
      if (option) {
        excludeScore = option.excludeScore;
      }
      return excludeScore;
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.dataChecks = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.errors.clear();
      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();

      this.$emit("onClearAnswer", this.componentData);
      if (!this.isFieldDisabled) {
        this.validateIt();
      }
    },
    onFieldChange() {
      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    validateCharacterLimit(answer, hasLimit, characterLimit) {
      if (!hasLimit) {
        return true;
      }
      if (answer.length > characterLimit) {
        this.hasFieldError = true;
        this.fieldErrorText = `Charcter limit can not be more than ${characterLimit}`;
        return true;
      }
      return false;
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.body] = option.score || 0;
        });
      }
    },
    checkForFieldErrors() {
      let { answer, characterLimited, textLimit, isSkippable, dataEditChecks } = this.componentData;
      this.componentData.dataChecks = [];
      this.resetAllErrors();

      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer == undefined || answer == "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              softDataCheck = true;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: "soft",
                message: this.fieldWarningText
              });
              return false;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (answer == "undefined" || answer == "")) {
              this.hasFieldError = true;
              this.fieldErrorText = `This field is required.`;
              isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (isSkippable && (answer == "" || answer == undefined)) {
        return;
      }
      if (this.validateCharacterLimit(answer, characterLimited, textLimit)) {
        return;
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.scoresMap[this.componentData.answer];
        this.componentData.actualScore = this.scoresMap[this.componentData.answer];
        for (let i = 0; i < this.componentData.options.length; i++) {
          const option = this.componentData.options[i];
          if (option.body == this.componentData.answer) {
            if (option.id == this.componentData.otherOptionId && this.componentData.otherCommentSelectedField && this.mode == 1) {
              this.$toastr.success(this.componentData.otherCommentSelectedField);
            }
            this.componentData.optionId = option.id;
            this.componentData.index = i;
          }
        }
        this.$emit("onAnswerChange", this.componentData);
        this.checkForFieldErrors();
      });
    },
    validateIt() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          this.hasFieldError = true;
          this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
        }
      });
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId) {
        const sequence = this.componentData.options.length + 1;
        this.componentData.options.push({
          body: this.componentData.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: true,
          excludeScore: false,
          formattedBody: this.componentData.otherOptionContentField,
          id: this.componentData.otherOptionId,
          isAdvancedScoring: false,
          priority: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}

.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
